module.exports = __webpack_public_path__ + "static/us-flag-10b8d7e4511c4a11fd78c64c787a88be.png";